import {
    REQ_ADD_DATA_GROUP_USER,
    GET_ADD_DATA_GROUP_USER,
    REQ_ALL_COMPANY,
    GET_ALL_COMPANY,
    REQ_POOL_COMPANY,
    GET_POOL_COMPANY,
    REQ_VEHICLE_COMPANY,
    GET_VEHICLE_COMPANY,
    REQ_TRANSIT_COMPANY,
    GET_TRANSIT_COMPANY,
    ALERT_MESSAGE_USER_MANAGE,
    REQ_ALL_GROUP,
    GET_ALL_GROUP,
    REQ_SET_USER_MANAGE,
    GET_SET_USER_MANAGE,
    REQ_ADD_GROUP,
    REQ_EDIT_GROUP,
    REQ_DELETE_GROUP,
    GET_ADD_GROUP,
    GET_EDIT_GROUP,
    GET_DELETE_GROUP,
    REQ_VISITED_PAGE,
    GET_VISITED_PAGE,
    SUCCESS_MESSAGE_MANAGE,
    ERROR_MESSAGE_MANAGE,
    HIDE_MESSAGE_MANAGE,
} from 'constants/ActionTypes';

export const reqDataGroupUser = () => {
    return {
        type: REQ_ADD_DATA_GROUP_USER
    }
} 

export const getDataGroupUser = (data) => {
    return {
        type: GET_ADD_DATA_GROUP_USER,
        action: data
    }
}

export const showMessage = (data) => {
    return {
        type: ALERT_MESSAGE_USER_MANAGE,
        action: data
    }
}

export const reqAllCompany = (data) => {
    return {
        type: REQ_ALL_COMPANY,
        action: data
    }
}

export const getAllCompany = () => {
    return {
        type: GET_ALL_COMPANY
    }
}

export const reqAllPool = (data) => {
    return {
        type: REQ_POOL_COMPANY,
        action: data
    }
}

export const getAllPool = (data) => {
    return {
        type: GET_POOL_COMPANY,
        action: data
    }
}

export const reqAllVehicle = (data) => {
    return {
        type: REQ_VEHICLE_COMPANY,
        action: data
    }
}

export const getAllVehicle = (data) => {
    return {
        type: GET_VEHICLE_COMPANY,
        action: data
    }
}

export const reqAllTransit = (data) => {
    return {
        type: REQ_TRANSIT_COMPANY,
        action: data
    }
}

export const getAllTransit = (data) => {
    return {
        type: GET_TRANSIT_COMPANY,
        action: data
    }
}

export const reqAllPackage = () => {
    return {
        type: REQ_ALL_PACKAGE,
    }
}


export const reqAllUserManage = () => {
    return {
        type: REQ_ALL_GROUP,
    }
}

export const getAllUserManage = (data) => {
    return {
        type: GET_ALL_GROUP,
        action: data
    }
}

export const reqAddUserManage = (data) => {
    return {
        type: REQ_ADD_GROUP,
        action: data
    }
}

export const getAddUserManage = (data) => {
    return {
        type: GET_ADD_GROUP,
        action: data
    }
}

export const reqEditUserManage = (data) => {
    return {
        type: REQ_EDIT_GROUP,
        action: data
    }
}

export const getEditUserManage = (data) => {
    return {
        type: GET_EDIT_GROUP,
        action: data
    }
}

export const reqDeleteUserManage = (data) => {
    return {
        type: REQ_DELETE_GROUP,
        action: data
    }
}

export const getDeleteUserManage = (data) => {
    return {
        type: GET_DELETE_GROUP,
        action: data
    }
}


export const reqSetUserManage = (data) => {
    return {
        type: REQ_SET_USER_MANAGE,
        action: data
    }
}

export const getSetUserManage = (data) => {
    return {
        type: GET_SET_USER_MANAGE,
        action: data
    }
}

export const reqVisitedPage = (data) => {
    return {
        type: REQ_VISITED_PAGE,
        action: data
    }
}

export const getVisitedPage = data => {
    return {
        type: GET_VISITED_PAGE,
        action: data
    }
}

export const successMessageManage = (data) => {
    return {
        type: SUCCESS_MESSAGE_MANAGE,
        action: data
    }
}

export const errorMessageManage = (data) => {
    return {
        type: ERROR_MESSAGE_MANAGE,
        action: data
    }
}

export const hideMessageManage = () => {
    return {
        type: HIDE_MESSAGE_MANAGE,
    }
}


// WEBPACK FOOTER //
// ./actions/UserManage.js